import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormControl, InputBase, MenuItem, Select, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { addColumn, addVarType } from "../../../../redux/slices/newTableSlice";

export default function TableInputs({ submit }) {
    const [newColumnName, setNewColumnName] = useState("")
    const [selectedVarType, setSelectedVarType] = useState("")

    const dispatch = useDispatch()

    const MenuProps = {
        PaperProps: {
          style: {
            backgroundColor: "#333333",
          },
        },
      };

    useEffect(() => {
       dispatch(addColumn(newColumnName))
       dispatch(addVarType(selectedVarType))
    }, [submit])

    return(
        <div className="modal-columns">
            <Typography
                sx={{
                    margin: "22px 28px 0px",
                    color: "#fff",
                    fontFamily: "Averta",
                    fontWeight: "400",
                    gridColumn: "1",
                    placeholder: { color: "#"} }}>
                Column Name
            </Typography>
            <InputBase
                value={newColumnName}
                placeholder={"Column Name"}
                sx={{
                    backgroundColor: "#040417",
                    color: "#fff",
                    borderRadius: "9px",
                    pl: "10px",
                    minHeight: "45px",
                    margin: "5px 28px",
                    border: "1px solid #114BA3",
                    fontFamily: "Averta",
                    gridColumn: "1",
                }}
                hiddenLabel={true}
                id="outlined-basic"
                varian="filled"
                label=""
                onChange={(e) => setNewColumnName(e.target.value.replace(/[^a-zA-Z0-9_ ]/g, '').replace(" ", "_").replace(/^[^a-zA-Z]/, ''))}
            />
            <Typography
                sx={{
                    margin: "22px 28px 0px",
                    color: "#fff",
                    fontFamily: "Averta",
                    fontWeight: "400",
                    gridColumn: "2",
                    gridRow: "1" }}>
                Variable Type
            </Typography>
            <FormControl
                sx={{
                    backgroundColor: "#040417",
                    color: "#fff",
                    borderRadius: "9px",
                    pl: "10px",
                    minHeight: "45px",
                    margin: "5px 28px",
                    border: "1px solid #114BA3",
                    fontFamily: "Averta",
                    gridColumn: "2",
                    "& .MuiFilledInput-underline": {
                        borderBottom: "0px solid black !important",
                        },
                    "& .MuiSelect-icon": { color: "#fff" }
                }}
            >
                <Select
                    displayEmpty
                    value={selectedVarType}
                    input={<InputBase />}
                    sx={{
                        height: "45px",
                        color: selectedVarType ? "#fff" : "#6D6D79",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                    MenuProps={MenuProps}
                    IconComponent={ExpandMoreIcon}
                    onChange={(e) => setSelectedVarType(e.target.value)}
                >
                    <MenuItem disabled value="" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>Select Variable Type</em>
                    </MenuItem>
                    <MenuItem value="text" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>text</em>
                    </MenuItem>
                    <MenuItem value="smallint" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>smallint</em>
                    </MenuItem>
                    <MenuItem value="int" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>integer</em>
                    </MenuItem>
                    <MenuItem value="bigint" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>bigint</em>
                    </MenuItem>
                    <MenuItem value="real" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>real</em>
                    </MenuItem>
                    <MenuItem value="money" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>money</em>
                    </MenuItem>
                    <MenuItem value="boolean" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>boolean</em>
                    </MenuItem>
                    <MenuItem value="date" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>date</em>
                    </MenuItem>
                    <MenuItem value="timestamp" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>timestamp</em>
                    </MenuItem>
                    <MenuItem value="time" sx={{ color: "#fff", fontFamily: "Averta" }}>
                        <em>time</em>
                    </MenuItem>
                </Select>
            </FormControl>
        </div>
    )
}